const semanticClassNames = {
  root: 'text',
} as const;

export default semanticClassNames;
